import React from 'react';
import HekaosLogoImage from '../../data/Hekaos_Logo.png';

const HekaosLogo = ({ size = 64 }) => (
  <img
    src={HekaosLogoImage}
    alt="Hekaos Logo"
    style={{
      width: `${size}px`,
      height: `${size}px`,
      objectFit: 'contain',
    }}
  />
);

export default HekaosLogo;

